import React from 'react';
import * as C from "../componentsM/index"

const Testimonials = () => {
    return (
        <>


            <C.Hero title={"TESTIMONIALS"}
                tagLine={"The International School (TIS) Established In 1996"}
                image={"/hero/history.jpg"} />

            <C.Testimonial />

        </>
    )
}

export default Testimonials